import { HeaderBrand } from "./HeaderBrand";
import { HeaderActions } from "./HeaderActions";

interface IProps {
  isSidebarOpen: boolean;
  onToggleSidebar: () => void;
  isDesktop: boolean;
  /** Builder layout has no sidebar drawer and renders its own logo, so the
   *  header drops its desktop brand column and the mobile hamburger. */
  noSidebar?: boolean;
}

export const Header = ({
  isSidebarOpen,
  onToggleSidebar,
  isDesktop,
  noSidebar,
}: IProps) => (
  <header className="w-full">
    <div className="flex items-center justify-between px-2.5 py-2.5 md:px-3 md:py-3">
      <HeaderBrand
        isSidebarOpen={isSidebarOpen}
        onToggleSidebar={onToggleSidebar}
        isDesktop={isDesktop}
        noSidebar={noSidebar}
      />
      <HeaderActions />
    </div>
  </header>
);
